/**
 * Обёртка над localStorage/sessionStorage.
 *
 * На части iOS Safari / WebView `window.localStorage` бывает `null`
 * (не SecurityError, а именно null) → `localStorage.getItem(...)` даёт
 * `TypeError: null is not an object`. Zustand persist и ранние проверки
 * без try/catch роняют весь первый рендер.
 */
function wrap(getStorage) {
    return {
        getItem(name) {
            try {
                return getStorage()?.getItem(name) ?? null;
            }
            catch {
                return null;
            }
        },
        setItem(name, value) {
            try {
                getStorage()?.setItem(name, value);
            }
            catch {
                /* private mode / quota / null storage */
            }
        },
        removeItem(name) {
            try {
                getStorage()?.removeItem(name);
            }
            catch {
                /* ignore */
            }
        },
    };
}
/** Безопасный localStorage (для Zustand persist и разовых get/set). */
export const safeLocalStorage = wrap(() => {
    if (typeof window === "undefined")
        return null;
    return window.localStorage;
});
/** Безопасный sessionStorage. */
export const safeSessionStorage = wrap(() => {
    if (typeof window === "undefined")
        return null;
    return window.sessionStorage;
});
